import { useLayoutEffect, useRef, useState } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import { ListItem } from "styles/jss/Navigation.styles";
import SubMenu from "./SubMenu";

export default function MenuItems({ links, hasSubRoute, setOpen, setHeight }) {
  const [subMenu, setSubmenu] = useState([]);
  const [toggleOpen, setToggleOpen] = useState(false);
  const onMouseEnter = subLinks => {
    setOpen(true);
    setToggleOpen(true);
    setSubmenu(subLinks);
  };
  const onMouseLeave = () => {
    setToggleOpen(false);
    setOpen(false);
    setSubmenu([]);
  };
  const panel = {
    open: {
      opacity: 1,
      visibility: "inherit",
    },
    close: {
      opacity: 0,
      visibility: "hidden",
    },
  };

  const ref = useRef();
  useLayoutEffect(() => {
    if (toggleOpen) {
      setHeight(ref?.current?.getBoundingClientRect().height);
    }
  }, [toggleOpen]);

  return !hasSubRoute ? (
    <ListItem>
      <Link href={links.href}>
        <a className="linkName" aria-label={links.name}>
          {links.name}
        </a>
      </Link>
    </ListItem>
  ) : (
    <ListItem
      onMouseEnter={() => onMouseEnter(links.submenu)}
      onMouseLeave={onMouseLeave}
    >
      <span className="linkName">{links.name}</span>
      <motion.div
        className={"panel"}
        variants={panel}
        animate={toggleOpen ? "open" : "close"}
        transition={{
          delay: 0.1,
        }}
      >
        <div className="card">
          <div className={"linksWrapper"} ref={ref}>
            <SubMenu menus={subMenu} onMouseLeave={onMouseLeave} />
          </div>
        </div>
      </motion.div>
    </ListItem>
  );
}
